// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-content {
  min-width: 420px;
  padding: 10px 0;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.text-danger {
  color: #dc3545;
}

.alert {
  padding: 12px;
  border-radius: 4px;
}

.alert-info {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
}

.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.align-middle {
  vertical-align: middle;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mt-3 {
  margin-top: 1rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.text-center {
  text-align: center;
}

.pat-expiry-fields {
  -moz-column-gap: 8px;
       column-gap: 8px;
  row-gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/pat-update-dialog/pat-update-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAe;OAAf,eAAe;EACf,YAAY;AACd","sourcesContent":[".dialog-content {\n  min-width: 420px;\n  padding: 10px 0;\n}\n\n.form-label {\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  display: block;\n}\n\n.text-danger {\n  color: #dc3545;\n}\n\n.alert {\n  padding: 12px;\n  border-radius: 4px;\n}\n\n.alert-info {\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  color: #0c5460;\n}\n\n.alert-warning {\n  background-color: #fff3cd;\n  border: 1px solid #ffeeba;\n  color: #856404;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.alert-success {\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.align-middle {\n  vertical-align: middle;\n}\n\n.mr-2 {\n  margin-right: 0.5rem;\n}\n\n.mb-3 {\n  margin-bottom: 1rem;\n}\n\n.mt-3 {\n  margin-top: 1rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.pat-expiry-fields {\n  column-gap: 8px;\n  row-gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
